import rawDebug from 'debug';

import type { DebugKey } from '../enums';

/**
 * Extends "debug" by appending the request id to logs
 * @param namespace - an enum of debug namespaces
 * @param requestId - the request id
 * @returns a function for logging debug information
 */
export const createDebug = (namespace: DebugKey, requestId?: string) => {
  const debug = rawDebug(namespace);

  return (formatter: string, ...args: unknown[]) => {
    const formatting = requestId ? `%s ${formatter}` : formatter;
    const argsWithRequestId = requestId ? [`requestId ${requestId}`, ...args] : args;

    return debug(formatting, ...argsWithRequestId);
  };
};
